/*
 * Translation between the two shapes the asset selection is held in.
 *
 * Redux (manageInventory.selection) stores prefixed keys - `select-<installBaseID>` - while
 * react-table's useRowSelect keys selectedRowIds by the bare row id. Every sync between the two
 * goes through here so the prefix is only spelled out in one place.
 */

export const SELECTION_PREFIX = 'select-';

/** `select-abc` -> `abc` */
export const toRowId = (selectionKey: string): string =>
    selectionKey.startsWith(SELECTION_PREFIX) ? selectionKey.slice(SELECTION_PREFIX.length) : selectionKey;

/** `abc` -> `select-abc` */
export const toSelectionKey = (rowId: string): string => `${SELECTION_PREFIX}${rowId}`;

/** Redux selection -> react-table selectedRowIds */
export const selectionToRowIds = (selection: string[]): Record<string, boolean> =>
    selection.reduce((acc, key) => {
        acc[toRowId(key)] = true;
        return acc;
    }, {} as Record<string, boolean>);

/** react-table selectedRowIds -> Redux selection */
export const rowIdsToSelection = (selectedRowIds: Record<string, boolean>): string[] =>
    Object.keys(selectedRowIds).map(toSelectionKey);

/** `workOrders` is scoped to the selected job, so on the All Assets list its presence means the asset is already on it */
export const isAlreadyOnJob = (
    installBase: { workOrders?: { id: string }[] | null | undefined },
    isAddWorkOrderMode: boolean
): boolean => isAddWorkOrderMode && Array.isArray(installBase.workOrders) && installBase.workOrders.length > 0;
